export const colors = {
  mainColor: "#3e4480",
  darkMainColor: "#262a52",
  gray: "#d8daeb",
  lightGray: "#e3e4e6",
  white: "#ffffff",
  black: "#000000",
};
